const hexToRgb = (hex) => {
  const m = hex.replace("#", "")
  const n = parseInt(
    m.length === 3
      ? m
          .split("")
          .map((c) => c + c)
          .join("")
      : m,
    16
  )
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

const rgbToHex = ({ r, g, b }) =>
  "#" +
  [r, g, b]
    .map((v) =>
      Math.max(0, Math.min(255, Math.round(v)))
        .toString(16)
        .padStart(2, "0")
    )
    .join("")

const mix = (hex, target, weight) => {
  const a = hexToRgb(hex)
  const b = hexToRgb(target)
  return rgbToHex({
    r: a.r + (b.r - a.r) * weight,
    g: a.g + (b.g - a.g) * weight,
    b: a.b + (b.b - a.b) * weight,
  })
}

const luminance = (hex) => {
  const { r, g, b } = hexToRgb(hex)
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255
}

export const getDepartmentColorScheme = (baseHex) => {
  const hex = /^#[0-9A-Fa-f]{6}$/.test(baseHex || "") ? baseHex : "#94A3B8"
  const isLight = luminance(hex) > 0.65

  return {
    base: hex,
    bg: mix(hex, "#FFFFFF", 0.88),
    border: mix(hex, "#FFFFFF", 0.65),
    text: isLight ? mix(hex, "#000000", 0.6) : mix(hex, "#000000", 0.15),
    badgeSolid: hex,
    senderText: mix(hex, "#000000", 0.1),
    statusRead: mix(hex, "#000000", 0.05),
    checkRead: hex,
    bubbleBorder: mix(hex, "#FFFFFF", 0.75),
    editRing: mix(hex, "#FFFFFF", 0.55),
    btnBg: hex,
    btnBgHover: mix(hex, "#000000", 0.12),
    arrow: mix(hex, "#000000", 0.05),
    selectBg: mix(hex, "#FFFFFF", 0.92),
    spinnerBorder: mix(hex, "#000000", 0.15),
    borderColor: hex, // для левой полоски reply-превью
  }
}
